import { render, staticRenderFns } from "./MainWorkOrders.vue?vue&type=template&id=8c3bed2e&"
import script from "./MainWorkOrders.vue?vue&type=script&lang=js&"
export * from "./MainWorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./MainWorkOrders.vue?vue&type=style&index=0&id=8c3bed2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports